import { createSlice } from "@reduxjs/toolkit";
import { geteceactivityskillThunk, createeceskillmasterThunk,updateeceskillmasterThunk,deleteeceskillmasterThunk } from "./EceSkillsetManager.Thunk";

const initialState = {
  data: [],
  loading: false,
  status: "",
  message: "",
  preferedlanguage: "",
  subject: "",
  clas: "",
  disable_content_button: true,
};

const EceSkillsetManagerSlice = createSlice({
  name: "eceskillsetmanagerslice",
  initialState,
  reducers: {
    preferedlanguage_change: (state, action) => {
      state.preferedlanguage = action.payload;
      state.data = [];
      state.subject = "";
      state.clas = "";
      state.disable_content_button = true;
    },
    subject_change: (state, action) => {
      state.subject = action.payload;
      state.data = [];
      state.clas = "";
      state.disable_content_button = true;
    },
    class_change: (state, action) => {
      state.clas = action.payload;
      state.data = [];
      state.disable_content_button = false;
    },
  },
  extraReducers: {
    [geteceactivityskillThunk.pending]: (state, action) => {
      state.data = [];
      state.loading = true;
      state.status = action.meta.requestStatus;
      state.message = "loading";
    },
    [geteceactivityskillThunk.fulfilled]: (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = "Ece Activity success";
    },
    [geteceactivityskillThunk.rejected]: (state, action) => {
      state.data = [];
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = action.error.message;
    },
    [createeceskillmasterThunk.pending]: (state, action) => {
      state.loading = true;
      state.status = action.meta.requestStatus;
      state.message = "loading";
    },
    [createeceskillmasterThunk.fulfilled]: (state, action) => {
      //console.log("slice action.payload: ", action.payload);
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = "Login success";
    },
    [createeceskillmasterThunk.rejected]: (state, action) => {
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = action.error.message;
    },
    [updateeceskillmasterThunk.pending]: (state, action) => {
      state.loading = true;
      state.status = action.meta.requestStatus;
      state.message = "loading";
    },
    [updateeceskillmasterThunk.fulfilled]: (state, action) => {
      //console.log("slice action.payload: ", action.payload);
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = "Login success";
    },
    [updateeceskillmasterThunk.rejected]: (state, action) => {
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = action.error.message;
    },
    [deleteeceskillmasterThunk.pending]: (state, action) => {
      state.loading = true;
      state.status = action.meta.requestStatus;
      state.message = "loading";
    },
    [deleteeceskillmasterThunk.fulfilled]: (state, action) => {
      //console.log("slice action.payload: ", action.payload);
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = "Login success";
    },
    [deleteeceskillmasterThunk.rejected]: (state, action) => {
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = action.error.message;
    },
  },
});

export const { preferedlanguage_change, class_change, subject_change } = EceSkillsetManagerSlice.actions;

export default EceSkillsetManagerSlice.reducer;
